import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MobileMenuService {
  private _isMobileMenuOpen = signal(false);

  // Read-only signal for components to subscribe to
  public readonly isMobileMenuOpen = this._isMobileMenuOpen.asReadonly();

  toggleMobileMenu(): void {
    this._isMobileMenuOpen.update(value => !value);
  }

  closeMobileMenu(): void {
    this._isMobileMenuOpen.set(false);
  }

  openMobileMenu(): void {
    this._isMobileMenuOpen.set(true);
  }
}
